import {addActionSheet} from "./action_sheet.js";
import {initializeLazyQueue} from "./lazy_queue.js";
import {closeActiveMenus, openMenu} from "./menu.js";
import {getPageVar} from "./variable.js";

export function initializeComponents(is_ajax = false) {
    initializeFormtools();
    initializeBtnSubmit();
    initializeAutoExpandTextarea();
    initMenu();
    initializeLazyQueue();

    if (!is_ajax) {
        preSelectMenuItems();
    }
}

const preSelectMenuItems = () => {
    const selected_menu_keys = getPageVar('selected_menu_keys', false);

    if (selected_menu_keys) {
        $.each(selected_menu_keys, function (menu_key, item_key) {
            const el_menu = $(`#${menu_key}`);

            if (el_menu.length === 0) {
                console.error(`Menu ID "${menu_key}" not found`);
            } else {
                const el_item = $(`[id="${item_key}"]`, el_menu);

                if (el_item.length === 0) {
                    console.error(`Cannot find Menu Item ID "${item_key}"`);

                } else {
                    if (el_menu.hasClass("footer-bar-6")) {
                        // only applicable to style .footer-bar-6
                        el_item.addClass('active-nav circle-nav');
                        el_item.append("<em></em><strong><u></u></strong>");

                    } else if (el_menu.hasClass('menu')) {
                        // anything with .menu
                        el_item.addClass('active-nav');

                    } else {
                        console.error(`Menu ID "${menu_key}" - Unknown menu type`);
                    }
                }
            }
        });
    }
}

const initializeBtnSubmit = () => {
    $(".btn-form_submit:not([data-submit-initialized='y'])").each(function () {
        $(this).attr("data-submit-initialized", 'y');

        const el_submit_target = $(this).data("submit-target") || false;

        if (el_submit_target) {
            $(this).off("click").on("click", function (event) {
                event.preventDefault();

                $(el_submit_target).trigger("submit");
            });
        }
    });
}

const initializeAutoExpandTextarea = () => {
    $("textarea.auto_expand:not([data-expand-initialized='y'])").each(function () {
        $(this).attr("data-expand-initialized", 'y');

        autoResize($(this));

        let last_timeout_id = null;

        $(this).off('keyup').on('keyup', function (e) {
            // enter key or delete key
            if ([8, 13].indexOf(e.keyCode) > -1) {
                if (!last_timeout_id) {
                    clearTimeout(last_timeout_id);
                    last_timeout_id = null;
                }

                last_timeout_id = setTimeout(() => {
                    autoResize($(this), function () {
                        last_timeout_id = null;
                    });
                }, 300);
            }
        });
    });

    function autoResize(el_textarea) {
        const el_clone = el_textarea.clone();
        el_clone.removeAttr("id style data-expand-initialized");
        el_clone.removeClass("auto_expand");

        $(".clone-textarea").remove();

        el_clone.addClass("clone-textarea");
        el_clone.addClass("bg-danger");
        el_clone.appendTo(el_textarea.parent());

        el_clone.height(1); // temporarily shrink textarea so that scrollHeight returns content height when content does not fill textarea
        el_textarea.height(el_clone.prop("scrollHeight"));

        el_clone.remove();
    }
}

const initializeFormtools = () => {
    $(".formtool:not([data-formtool-initialized='y'])").each(function () {
        $(this).attr("data-formtool-initialized", 'y');

        $(this).formTools({
            customOnSuccess: function (form, response) {
                const redirect_url = response.redirect_url || form.data("success_redirect") || false;

                if (redirect_url) {
                    location.href = redirect_url;

                } else if (response.hasOwnProperty('notification')) {
                    addActionSheet(response.notification);
                } else {
                    location.reload();
                }
            }
        });
    });
}

const initMenu = () => {
    $("[data-menu]:not([data-menu-initialized='y'])").each(function () {
        $(this).attr("data-menu-initialized", 'y');

        $(this).off("click").on("click", function (event) {
            event.preventDefault();

            openMenu($(this).data("menu"));
        });
    });

    $(".close-menu:not([data-menu-initialized='y'])").each(function () {
        $(this).attr("data-menu-initialized", 'y');

        $(this).off("click").on("click", function (event) {
            event.preventDefault();

            closeActiveMenus();
        });
    });
}